import { Text, TextField } from "@fluentui/react";
import React, { ChangeEvent, ReactNode } from "react";
import { localize } from "src/l10n";
import { AuthenticationDataComponent } from "../AuthenticationDataComponent";

class CustomQueryStringInput extends AuthenticationDataComponent<any, any> {
    private instructions: string = localize("CUSTOM_QUERY_STRING_INSTRUCTIONS");

    constructor(props: any) {
        super(props);

        this.state = {
            data: {
                customQueryStringValue: ""
            },
            instructions: undefined,
            queryStringName: ""
        };

        this.onValueChanged = this.onValueChanged.bind(this);
    }

    public componentDidMount(): void {
        const data: any = JSON.parse(this.props.authenticationData);
        
        this.setState({
            instructions: data.instructions,
            queryStringName: data.customQueryStringName
        });
    }

    public getAuthenticationData(): string {
        return JSON.stringify(this.state.data);
    }    
    
    public isValid(): boolean {
        return this.state.data.customQueryStringValue.length > 0;
    }

    public onValueChanged(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            data: {
                customQueryStringValue: event.target.value.trim()
            }
        }, () => {
            this.isValid();

            if (typeof this.props.onChange === "function") {
                this.props.onChange();
            }
        });
    }
    
    public render(): ReactNode {
        const instructions = this.state.instructions || this.instructions;

        return (
            <div className="CustomQueryStringInput">
                <p
                    className="instructions"
                    dangerouslySetInnerHTML={{
                        __html: instructions
                    }}
                />
                <TextField
                    label={this.state.queryStringName}
                    name="customQueryStringValue"
                    onChange={this.onValueChanged}
                    value={this.state.data.customQueryStringValue}
                />
            </div>
        );
    }
}

export default CustomQueryStringInput;